import apiHelper from '@/services/helper'
import apiHelperFinance from '@/services/helperFinance'

const localCacheGetShopByShopID = {}

const getListShopByUserID = async (param) => {
    try {
        let url = '/admin/shop/get'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const searchListShop = async (param, cancelToken = null) => {
    try {
        let url = '/admin/shop/search'
        return (await apiHelper.postWithFirebaseToken(url, param, true, cancelToken)).data
    } catch (error) {
        throw error
    }
}

const updateShop = async (param) => {
    try {
        let url = '/admin/shop/update'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const searchOrderManage = async (param) => {
    try {
        let url = '/admin/shop/new-search-order-manage'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getShopByShopID = async (param) => {
    if (localCacheGetShopByShopID[param.shop_id]) {
        return localCacheGetShopByShopID[param.shop_id]
    }

    try {
        let url = '/admin/shop/get-by-id'
        const result = (await apiHelperFinance.getWithFirebaseToken(url, param)).data
        localCacheGetShopByShopID[param.shop_id] = result
        return result
    } catch (error) {
        throw new Error(error)
    }
}

const createShop = async (param) => {
    try {
        let url = '/admin/shop/create'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getUserCode = async (param) => {
    try {
        let url = '/admin/shop/get-by-user-id'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getAllShop = async (param) => {
    try {
        let url = '/admin/shop/get-all'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getShopById = async (id) => {
    try {
        let url = '/admin/shop/get-by-id?shop_id=' + id
        // TODO response.data
        return (await apiHelperFinance.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getAllShopExcel = async (param) => {
    try {
        let url = '/admin/shop/export'
        return (await apiHelper.getWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}
const getAllShopExportOrderExcel = async (param) => {
    try {
        let url = '/admin/shop/get-all-name'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getAllShopIsHasPickUpAddress = async (param) => {
    try {
        let url = '/admin/shop/get-all-is-has-pickup-address'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getAllShopNew = async (param) => {
    try {
        let url = '/admin/shop/get-all'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    getListShopByUserID,
    searchListShop,
    updateShop,
    getShopByShopID,
    createShop,
    getAllShop,
    getShopById,
    getAllShopExcel,
    searchOrderManage,
    getUserCode,
    getAllShopIsHasPickUpAddress,
    getAllShopExportOrderExcel,
    getAllShopNew
}
